import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { NexsysMonitorService, OriginSourceData } from '../../service/nexsys-monitor.service';
import { Store } from '@ngxs/store';
import { ORIGIN, SUBURLS, URLS } from '../model/nexsys-monitor.constant';
import { SetOrderMonitorOrigin } from '../state/actions/nexsys-monitor.actions';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Secure } from '@cv-invision/core';
import { PERMISSION } from '../../model/global-configuration.constant';
import { ValueLinkMonitorService } from '../../service/value-link.service';

@Component({
	selector: 'cv-nexsys-monitor-header',
	templateUrl: './nexsys-monitor-header.component.html',
	styleUrls: ['./nexsys-monitor-header.component.scss']
})
export class NexsysMonitorHeaderComponent implements OnInit, OnDestroy {
	nexsysOrderId: string;
	xpanseTransactionId: string;
	headerSubtitle: string;
	showBackLink: boolean;
	originSelected: string;
	mainURL: string;
	origin: string;
	originRedirect: string;
	originList: Array<string>;
	btnText: string;
	canSearch: boolean;
	placeholderInput: string;
	placeholderInputTransactionId: string;
	noReload: boolean;
	clearSourceSelected: boolean;
	private atComponentDestroy: Subject<any> = new Subject<any>();

	constructor(
		private route: ActivatedRoute,
		private store: Store,
		private router: Router,
		private nexsysMonitorService: NexsysMonitorService,
		private valueLinkService: ValueLinkMonitorService,
		private location: Location
	) {
		this.showBackLink = false;
		this.originList = [];
	}

	ngOnInit(): void {
		this.addNexsysOrigin();
		this.addNexsysOrphanOrigin();
		this.addValutrustOrigin();
		this.addXpanseOrigin();
		this.addOrderExternalOrigin();
		this.addFNCOrigin();
		this.addEVOOrigin();
		this.addValueLink();
		this.addConnexions();
		this.addLendingQB();

		if (this.originList.length) {
			this.origin = this.originList[0];
		}

		if (this.router.url.includes(URLS.NEXSYS)) {
			this.origin = ORIGIN.Nexsys;
			this.mainURL = URLS.NEXSYS;
			this.placeholderInput = `${this.origin} OrderId`;
		} else if (this.router.url.includes(URLS.NEXSYS_ORPHAN)) {
			this.origin = ORIGIN.NexsysLegacy;
			this.mainURL = URLS.NEXSYS_ORPHAN;
			this.placeholderInput = `${this.origin} OrderId`;
		} else if (this.router.url.includes(URLS.VALUTRUST)) {
			this.origin = ORIGIN.Valutrust;
			this.mainURL = URLS.VALUTRUST;
			this.placeholderInput = `${this.origin} OrderId`;
		} else if (this.router.url.includes(URLS.XPANSE)) {
			this.origin = ORIGIN.Xpanse;
			this.mainURL = URLS.XPANSE;
			this.placeholderInput = `${this.origin} SPN ID`;
			this.placeholderInputTransactionId = `${this.origin} Transaction ID`;
		} else if (this.router.url.includes(URLS.ORDER_EXTERNAL)) {
			this.origin = ORIGIN.OrderExternal;
			this.mainURL = URLS.ORDER_EXTERNAL;
			this.placeholderInput = `Class order Id`;
		} else if (this.router.url.includes(URLS.FNC)) {
			this.origin = ORIGIN.FNC;
			this.mainURL = URLS.FNC;
			this.placeholderInput = `${this.origin} OrderId`;
		} else if (this.router.url.includes(URLS.EVO)) {
			this.origin = ORIGIN.EVO;
			this.mainURL = URLS.EVO;
			this.placeholderInput = `${this.origin} OrderId`;
		} else if (this.router.url.includes(URLS.VALUE_LINK)) {
			this.origin = ORIGIN.ValueLink;
			this.mainURL = URLS.VALUE_LINK;
			this.placeholderInput = `${this.origin} OrderId`;
		} else if (this.router.url.includes(URLS.CONNEXIONS)) {
			this.origin = ORIGIN.Connexions;
			this.mainURL = URLS.CONNEXIONS;
			this.placeholderInput = `${this.origin} OrderId`;
		} else if (this.router.url.includes(URLS.LENDINGQB)) {
			this.origin = ORIGIN.Lendingqb;
			this.mainURL = URLS.LENDINGQB;
			this.placeholderInput = `${this.origin} OrderId`;
		} 
 
		if (this.router.url && this.router.url.includes(SUBURLS.LOGS)) {
			this.headerSubtitle = 'Callback Logs ';
			this.originRedirect = SUBURLS.LOGS;
		}

		if (this.router.url && this.router.url.includes(SUBURLS.ORDERS)) {
			this.headerSubtitle = 'Orders';
			this.originRedirect = SUBURLS.ORDERS;
		}

		if (this.router.url && this.router.url.includes(SUBURLS.ORDERLOGS)) {
			this.headerSubtitle = 'Order Logs ';
			this.originRedirect = SUBURLS.ORDERLOGS;
			this.showBackLink = true;
		}

		this.originSelected = this.origin;
		this.canSearch = !!this.originSelected;
		this.btnText = `${this.origin} Order log`;
		this.nexsysMonitorService
			.getReloadListListener()
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((data: OriginSourceData) => {
				if (data.isHeaderChange) {
					this.origin = data.origin;
					this.clearSourceSelected = this.origin ? false : true;
					this.originSelected = data.origin;

					if (this.originSelected === ORIGIN.Xpanse) {
						this.placeholderInput = `${this.originSelected} SPN ID`;
						this.placeholderInputTransactionId = `${this.originSelected} Transaction ID`;
					}

					this.canSearch = !!this.originSelected;
					this.btnText = `${this.origin || ''} Order log`;
					this.placeholderInput = `${this.origin || ''} OrderId`;
				}
			});
	}

	@Secure(PERMISSION.NEXSYS)
	private addNexsysOrigin(): void {
		this.originList.push(ORIGIN.Nexsys);
	}

	@Secure(PERMISSION.NEXSYS_ORPHAN)
	private addNexsysOrphanOrigin(): void {
		if (this.router.url && !this.router.url.includes(SUBURLS.ORDERS) && !this.router.url.includes(SUBURLS.ORDERLOGS)) {
			this.originList.push(ORIGIN.NexsysLegacy);
		}
	}

	@Secure(PERMISSION.VALUTRUST)
	private addValutrustOrigin(): void {
		this.originList.push(ORIGIN.Valutrust);
	}

	@Secure(PERMISSION.XPANSE)
	private addXpanseOrigin(): void {
		this.originList.push(ORIGIN.Xpanse);
	}

	@Secure(PERMISSION.FNC)
	private addFNCOrigin(): void {
		this.originList.push(ORIGIN.FNC);
	}

	@Secure(PERMISSION.EVO)
	private addEVOOrigin(): void {
		this.originList.push(ORIGIN.EVO);
	}

	@Secure(PERMISSION.ORDERS_EXTERNAL)
	private addOrderExternalOrigin(): void {
		if (this.router.url && !this.router.url.includes(SUBURLS.ORDERS)) {
			this.originList.push(ORIGIN.OrderExternal);
		}
	}

	@Secure(PERMISSION.VALUE_LINK)
	private addValueLink(): void {
		this.originList.push(ORIGIN.ValueLink);
	}

	@Secure(PERMISSION.CONNEXIONS)
	private addConnexions(): void {
		this.originList.push(ORIGIN.Connexions);
	}

	@Secure(PERMISSION.LENDING_QB)
	private addLendingQB(): void {
		this.originList.push(ORIGIN.Lendingqb);
	}

	/**
	 * search order by Nexsys orderID
	 */
	onSearchOrder(): void {
		if (this.nexsysOrderId) {
			this.router.routeReuseStrategy.shouldReuseRoute = () => false;
			this.router.onSameUrlNavigation = 'reload';
			if (!this.mainURL) {
				this.onOriginSelected(this.originSelected);
			}

			if (this.origin === ORIGIN.Xpanse) {
				if (this.xpanseTransactionId) {
					this.router.navigate(
						[`/global-configuration/${this.mainURL}/order-log/`, this.xpanseTransactionId, this.nexsysOrderId],
						{
							relativeTo: this.route,
							queryParamsHandling: 'preserve'
						}
					);
				}
			} else if (this.origin === ORIGIN.ValueLink) {
				this.router.navigate(
					[`/global-configuration/${this.mainURL}/logs`],
					{
						relativeTo: this.route,
						queryParamsHandling: 'preserve'
					}
				);
			} else {
				this.router.navigate(
					[`/global-configuration/${this.mainURL}/order-log/`, this.nexsysOrderId],
					{
						relativeTo: this.route,
						queryParamsHandling: 'preserve'
					}
				);
			}
		}
	}

	/**
	 * set origin source
	 */
	onOriginSelected($event: any): void {
		this.canSearch = !!$event;
		this.btnText = `${$event || ''} Order log`;
		this.placeholderInput = `${$event || ''} OrderId`;
		if ($event) {
			this.clearSourceSelected = false;
			this.store.dispatch(new SetOrderMonitorOrigin($event));

			switch ($event) {
				case ORIGIN.Nexsys:
					this.mainURL = URLS.NEXSYS;
					break;
				case ORIGIN.NexsysLegacy:
					this.mainURL = URLS.NEXSYS_ORPHAN;
					break;
				case ORIGIN.Valutrust:
					this.mainURL = URLS.VALUTRUST;
					break;
				case ORIGIN.Xpanse:
					this.mainURL = URLS.XPANSE;
					this.placeholderInput = `${$event} SPN ID`;
					this.placeholderInputTransactionId = `${$event} Transaction ID`;
					break;
				case ORIGIN.OrderExternal:
					this.mainURL = URLS.ORDER_EXTERNAL;
					break;
				case ORIGIN.FNC:
					this.mainURL = URLS.FNC;
					break;
				case ORIGIN.EVO:
					this.mainURL = URLS.EVO;
					break;
				case ORIGIN.ValueLink:
					this.mainURL = URLS.VALUE_LINK;
					break;
				case ORIGIN.Connexions:
					this.mainURL = URLS.CONNEXIONS;
					break;
				case ORIGIN.Lendingqb:
					this.mainURL = URLS.LENDINGQB;
					break;
			}

			if (this.originRedirect === SUBURLS.LOGS && this.origin !== $event) {
				this.router.navigate([`global-configuration/${this.mainURL}/logs`]);
			}
			if (this.originRedirect === SUBURLS.ORDERS && (this.origin || this.origin !== $event)) {
				this.nexsysMonitorService.reloadList({ isDirty: true, origin: $event });
			}
			this.origin = $event;
		}
	}

	/**
	 * Go back
	 */
	goBack(): void {
		this.location.back();
	}

	/**
	 * Calls service to communicate with Inbox component to reload the grid.
	 */
	reloadList(): void {
		this.nexsysMonitorService.reloadList({ reload: true });
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.unsubscribe();
		this.nexsysMonitorService.reloadList(
			{
				reload: false,
				isDirty: false,
				isHeaderChange: false,
				origin: null
			});
		this.originList = [];
	}
}
